import { demoPdf, images } from "../../images";

export const BViewProfileData = [
  {
    mainTab: "Profile",
    subTab: [
      // {
      //   tabName: "OverView",
      //   about: [
      //     {
      //       title: "About",
      //       desc: [
      //         `At Atinner Interior Firm, we believe architecture is a blend of art, science, and environmental responsibility. Our team of experienced architects and designers is dedicated to transforming ideas into innovative, sustainable spaces that elevate everyday living. From residential to commercial projects, we collaborate closely with our clients to create functional, aesthetically captivating designs that not only meet today’s needs but also inspire future generations.`,
      //       ],
      //     },
      //   ],
      //   products: [
      //     {
      //       title: "Our Products/Services",
      //       radioField: [
      //         "Façade Design",
      //         "Universal Design",
      //         "Mechanical",
      //         "Kitchen & Bath Design",
      //         "Renovation & Restoration",
      //       ],
      //     },
      //   ],
      //   focus: [
      //     {
      //       title: "Our Focus",
      //       focusData: ["Luxury", "Affordable", "Good Value", "Mass-Market"],
      //     },
      //   ],
      // },
      {
        tabName: "Gallery",
        gallery: [
          {
            title: "Project Photos & Renders",
            ctaText: "View All",
            galleryImages: [
              {
                img: images.businessGallery00.image,
                alt: images.businessGallery00.alt,
              },
              {
                img: images.businessGallery00.image,
                alt: images.businessGallery00.alt,
              },
              // {
              //   img: images.businessGallery00.image,
              //   alt: images.businessGallery00.alt,
              // },
              // {
              //   img: images.businessGallery00.image,
              //   alt: images.businessGallery00.alt,
              // },
              // {
              //   img: images.businessGallery00.image,
              //   alt: images.businessGallery00.alt,
              // },
            ],
          },
          {
            title: "Products | Materials",
            ctaText: "View All",
            galleryImages: [
              {
                img: images.businessGallery00.image,
                alt: images.businessGallery00.alt,
              },
              {
                img: images.businessGallery02.image,
                alt: images.businessGallery02.alt,
              },
              {
                img: images.businessGallery03.image,
                alt: images.businessGallery03.alt,
              },
              {
                img: images.businessGallery04.image,
                alt: images.businessGallery04.alt,
              },
              {
                img: images.businessGallery05.image,
                alt: images.businessGallery05.alt,
              },
            ],
          },
          {
            title: "Sites In Progress",
            ctaText: "View All",
            galleryImages: [
              {
                img: images.businessGallery00.image,
                alt: images.businessGallery00.alt,
              },
              {
                img: images.businessGallery00.image,
                alt: images.businessGallery00.alt,
              },
              {
                img: images.businessGallery00.image,
                alt: images.businessGallery00.alt,
              },
              {
                img: images.businessGallery00.image,
                alt: images.businessGallery00.alt,
              },
              {
                img: images.businessGallery00.image,
                alt: images.businessGallery00.alt,
              },
            ],
          },
        ],
        companyProfile: [
          {
            title: "Firm/Company Profile",
            ctaText: "View All",
            profileList: [
              {
                pdfLink: demoPdf,
                title: "Loremipsum Set Dolor Dummy Text.PDF",
              },
              {
                pdfLink: "",
                title: "Loremipsum Set Dolor Dummy Text.PDF",
              },
              {
                pdfLink: "",
                title: "Loremipsum Set Dolor Dummy Text.PDF",
              },
            ],
          },
          {
            title: "Product Catalogue(s)",
            ctaText: "View All",
            profileList: [
              {
                pdfLink: demoPdf,
                title: "Loremipsum Set Dolor Dummy Text.PDF",
              },
              {
                pdfLink: "",
                title: "Loremipsum Set Dolor Dummy Text.PDF",
              },
              {
                pdfLink: "",
                title: "Loremipsum Set Dolor Dummy Text.PDF",
              },
            ],
          },
        ],
        // ratingData: [
        //   {
        //     name: "Joana Perkins",
        //     thumb: images.rating01.image,
        //     rating: 3,
        //     desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
        //   },
        //   {
        //     name: "Joana Perkins",
        //     thumb: images.rating01.image,
        //     rating: 3,
        //     desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
        //   },
        //   {
        //     name: "Joana Perkins",
        //     thumb: images.rating01.image,
        //     rating: 3,
        //     desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
        //   },
        //   {
        //     name: "Joana Perkins",
        //     thumb: images.rating01.image,
        //     rating: 3,
        //     desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
        //   },
        //   {
        //     name: "Joana Perkins",
        //     thumb: images.rating01.image,
        //     rating: 3,
        //     desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
        //   },
        //   {
        //     name: "Joana Perkins",
        //     thumb: images.rating01.image,
        //     rating: 3,
        //     desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
        //   },

        // ],
      },
      {
        tabName: "PDFs",
      },
      {
        tabName: "Contact",
      },
      // {
      //   tabName: "Events",
      // },
    ],
  },
  {
    mainTab: "Insights",
    subTab: [
      {
        tabName: "OverView2",
        about: [
          {
            title: "About",
            desc: [
              `At Atinner Interior Firm, we believe architecture is a blend of art, science, and environmental responsibility. Our team of experienced architects and designers is dedicated to transforming ideas into innovative, sustainable spaces that elevate everyday living. From residential to commercial projects, we collaborate closely with our clients to create functional, aesthetically captivating designs that not only meet today’s needs but also inspire future generations.`,
            ],
          },
        ],
        products: [
          {
            title: "Our Products/Services",
            radioField: [
              "Façade Design",
              "Universal Design",
              "Mechanical",
              "Kitchen & Bath Design",
              "Renovation & Restoration",
            ],
          },
        ],
        focus: [
          {
            title: "Our Focus",
            focusData: ["Luxury", "Affordable", "Good Value", "Mass-Market"],
          },
        ],
      },
      {
        tabName: "Gallery",
        gallery: [
          {
            title: "Project Photos & Renders",
            galleryImages: [
              {
                img: images.businessGallery01.image,
                alt: images.businessGallery01.alt,
              },
              {
                img: images.businessGallery02.image,
                alt: images.businessGallery02.alt,
              },
              {
                img: images.businessGallery03.image,
                alt: images.businessGallery03.alt,
              },
              {
                img: images.businessGallery04.image,
                alt: images.businessGallery04.alt,
              },
              {
                img: images.businessGallery05.image,
                alt: images.businessGallery05.alt,
              },
            ],
          },
          {
            title: "Products | Materials",
            galleryImages: [
              {
                img: images.businessGallery01.image,
                alt: images.businessGallery01.alt,
              },
              {
                img: images.businessGallery02.image,
                alt: images.businessGallery02.alt,
              },
              {
                img: images.businessGallery03.image,
                alt: images.businessGallery03.alt,
              },
              {
                img: images.businessGallery04.image,
                alt: images.businessGallery04.alt,
              },
              {
                img: images.businessGallery05.image,
                alt: images.businessGallery05.alt,
              },
            ],
          },
          {
            title: "Sites In Progress",
            galleryImages: [
              {
                img: images.businessGallery01.image,
                alt: images.businessGallery01.alt,
              },
              {
                img: images.businessGallery02.image,
                alt: images.businessGallery02.alt,
              },
              {
                img: images.businessGallery03.image,
                alt: images.businessGallery03.alt,
              },
              {
                img: images.businessGallery03.image,
                alt: images.businessGallery03.alt,
              },
              {
                img: images.businessGallery03.image,
                alt: images.businessGallery03.alt,
              },
            ],
          },
        ],
        companyProfile: [
          {
            title: "Firm/Company Profile",
            profileList: [
              {
                pdfLink: demoPdf,
                title: "Loremipsum Set Dolor Content Dummy Text.PDF",
              },
              {
                pdfLink: "",
                title: "Loremipsum Set Dolor Content Dummy Text.PDF",
              },
              {
                pdfLink: "",
                title: "Loremipsum Set Dolor Content Dummy Text.PDF",
              },
              {
                pdfLink: "",
                title: "Loremipsum Set Dolor Dummy Text.PDF",
              },
              {
                pdfLink: "",
                title: "Loremipsum Set Dolor Dummy Text.PDF",
              },
              {
                pdfLink: "",
                title: "Loremipsum Set Dolor Dummy Text.PDF",
              },
              {
                pdfLink: "",
                title: "Loremipsum Set Dolor Dummy Text.PDF",
              },
              {
                pdfLink: "",
                title: "Loremipsum Set Dolor Dummy Text.PDF",
              },
            ],
          },
          // {
          //   title: "Product Catalogue(s)",
          //   profileList: [
          //     {
          //       pdfLink: demoPdf,
          //       title: "Loremipsum Set Dolor Dummy Text.PDF",
          //     },
          //     {
          //       pdfLink: "",
          //       title: "Loremipsum Set Dolor Dummy Text.PDF",
          //     },
          //     {
          //       pdfLink: "",
          //       title: "Loremipsum Set Dolor Dummy Text.PDF",
          //     },
          //   ],
          // },
        ],
        ratingData: [
          {
            name: "Joana Perkins",
            thumb: images.rating01.image,
            rating: 3,
            desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
          },
          {
            name: "Joana Perkins",
            thumb: images.rating01.image,
            rating: 3,
            desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
          },
        ],
      },
      {
        tabName: "Jobs",
      },
      {
        tabName: "Courses",
      },
      {
        tabName: "Events",
      },
    ],
  },
  // {
  //   mainTab: "Chat History",
  //   subTab: [
  //     {
  //       tabName: "OverView3",
  //       about: [
  //         {
  //           title: "About",
  //           desc: [
  //             `At Atinner Interior Firm, we believe architecture is a blend of art, science, and environmental responsibility. Our team of experienced architects and designers is dedicated to transforming ideas into innovative, sustainable spaces that elevate everyday living. From residential to commercial projects, we collaborate closely with our clients to create functional, aesthetically captivating designs that not only meet today’s needs but also inspire future generations.`,
  //           ],
  //         },
  //       ],
  //       products: [
  //         {
  //           title: "Our Products/Services",
  //           radioField: [
  //             "Façade Design",
  //             "Universal Design",
  //             "Mechanical",
  //             "Kitchen & Bath Design",
  //             "Renovation & Restoration",
  //           ],
  //         },
  //       ],
  //       focus: [
  //         {
  //           title: "Our Focus",
  //           focusData: ["Luxury", "Affordable", "Good Value", "Mass-Market"],
  //         },
  //       ],
  //     },
  //     {
  //       tabName: "Gallery",
  //       gallery: [
  //         {
  //           title: "Project Photos & Renders",
  //           galleryImages: [
  //             {
  //               img: images.businessGallery01.image,
  //               alt: images.businessGallery01.alt,
  //             },
  //             {
  //               img: images.businessGallery02.image,
  //               alt: images.businessGallery02.alt,
  //             },
  //             {
  //               img: images.businessGallery03.image,
  //               alt: images.businessGallery03.alt,
  //             },
  //             {
  //               img: images.businessGallery04.image,
  //               alt: images.businessGallery04.alt,
  //             },
  //             {
  //               img: images.businessGallery05.image,
  //               alt: images.businessGallery05.alt,
  //             },
  //           ],
  //         },
  //         {
  //           title: "Products | Materials",
  //           galleryImages: [
  //             {
  //               img: images.businessGallery01.image,
  //               alt: images.businessGallery01.alt,
  //             },
  //             {
  //               img: images.businessGallery02.image,
  //               alt: images.businessGallery02.alt,
  //             },
  //             {
  //               img: images.businessGallery03.image,
  //               alt: images.businessGallery03.alt,
  //             },
  //             {
  //               img: images.businessGallery04.image,
  //               alt: images.businessGallery04.alt,
  //             },
  //             {
  //               img: images.businessGallery05.image,
  //               alt: images.businessGallery05.alt,
  //             },
  //           ],
  //         },
  //         {
  //           title: "Sites In Progress",
  //           galleryImages: [
  //             {
  //               img: images.businessGallery01.image,
  //               alt: images.businessGallery01.alt,
  //             },
  //             {
  //               img: images.businessGallery02.image,
  //               alt: images.businessGallery02.alt,
  //             },
  //             {
  //               img: images.businessGallery03.image,
  //               alt: images.businessGallery03.alt,
  //             },
  //             {
  //               img: images.businessGallery03.image,
  //               alt: images.businessGallery03.alt,
  //             },
  //             {
  //               img: images.businessGallery03.image,
  //               alt: images.businessGallery03.alt,
  //             },
  //           ],
  //         },
  //       ],
  //       companyProfile: [
  //         {
  //           title: "Firm/Company Profile",
  //           profileList: [
  //             {
  //               pdfLink: demoPdf,
  //               title: "Loremipsum Set Dolor Dummy Text.PDF",
  //             },
  //             {
  //               pdfLink: "",
  //               title: "Loremipsum Set Dolor Dummy Text.PDF",
  //             },
  //             {
  //               pdfLink: "",
  //               title: "Loremipsum Set Dolor Dummy Text.PDF",
  //             },
  //           ],
  //         },
  //         {
  //           title: "Product Catalogue(s)",
  //           profileList: [
  //             {
  //               pdfLink: demoPdf,
  //               title: "Loremipsum Set Dolor Dummy Text.PDF",
  //             },
  //             {
  //               pdfLink: "",
  //               title: "Loremipsum Set Dolor Dummy Text.PDF",
  //             },
  //             {
  //               pdfLink: "",
  //               title: "Loremipsum Set Dolor Dummy Text.PDF",
  //             },
  //           ],
  //         },
  //       ],
  //       ratingData: [
  //         {
  //           name: "Joana Perkins",
  //           thumb: images.rating01.image,
  //           rating: 3,
  //           desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
  //         },
  //         {
  //           name: "Joana Perkins",
  //           thumb: images.rating01.image,
  //           rating: 3,
  //           desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
  //         },
  //       ],
  //     },
  //     {
  //       tabName: "Jobs",
  //     },
  //     {
  //       tabName: "Courses",
  //     },
  //     // {
  //     //   tabName: "Events",
  //     // },
  //   ],
  // },
];

export const BeditOverviewData = [
  {
    tabName: "OverView",
    about: [
      {
        title: "About",
        desc: [
          `At Atinner Interior Firm, we believe architecture is a blend of art, science, and environmental responsibility. Our team of experienced architects and designers is dedicated to transforming ideas into innovative, sustainable spaces that elevate everyday living. From residential to commercial projects, we collaborate closely with our clients to create functional, aesthetically captivating designs that not only meet today’s needs but also inspire future generations.`,
        ],
      },
    ],
    products: [
      {
        title: "Our Products/Services",
        radioField: [
          "Façade Design",
          "Universal Design",
          "Mechanical",
          "Kitchen & Bath Design",
          "Renovation & Restoration",
        ],
      },
    ],
    focus: [
      {
        title: "Our Focus",
        focusData: ["Luxury", "Affordable", "Good Value", "Mass-Market"],
      },
    ],
  },
];

export const BeditGridImagesData = [
  {
    title: "Products | Materials",
    galleryImages: [
      {
        img: images.businessGallery01.image,
        alt: images.businessGallery01.alt,
      },
      {
        img: images.businessGallery01.image,
        alt: images.businessGallery01.alt,
      },
      {
        img: images.businessGallery01.image,
        alt: images.businessGallery01.alt,
      },
      {
        img: images.businessGallery01.image,
        alt: images.businessGallery01.alt,
      },
      {
        img: images.businessGallery01.image,
        alt: images.businessGallery01.alt,
      },
    ],
  },
  {
    title: "Sites In Progress",
    galleryImages: [
      {
        img: images.businessGallery01.image,
        alt: images.businessGallery01.alt,
      },
      {
        img: images.businessGallery01.image,
        alt: images.businessGallery01.alt,
      },
      {
        img: images.businessGallery01.image,
        alt: images.businessGallery01.alt,
      },
      {
        img: images.businessGallery01.image,
        alt: images.businessGallery01.alt,
      },
      {
        img: images.businessGallery01.image,
        alt: images.businessGallery01.alt,
      },
    ],
  },
];

export const ratingData = [
  {
    name: "Joana Perkins",
    thumb: images.rating01.image,
    rating: 3,
    desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
  },
  {
    name: "Joana Perkins",
    thumb: images.rating01.image,
    rating: 3,
    desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
  },
  {
    name: "Joana Perkins",
    thumb: images.rating01.image,
    rating: 3,
    desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
  },
  {
    name: "Joana Perkins",
    thumb: images.rating01.image,
    rating: 3,
    desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
  },
  {
    name: "Joana Perkins",
    thumb: images.rating01.image,
    rating: 3,
    desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
  },
  {
    name: "Joana Perkins",
    thumb: images.rating01.image,
    rating: 3,
    desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
  },
  {
    name: "Joana Perkins",
    thumb: images.rating01.image,
    rating: 3,
    desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
  },
  {
    name: "Joana Perkins",
    thumb: images.rating01.image,
    rating: 3,
    desc: "Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore enim ad minim veniam.",
  },
];
